/* ─── Popup ─── */

.popup {
  font: var(--type-body-md);
  letter-spacing: var(--tracking-body-md);
  background: var(--md-inverse-surface);
  color: var(--md-inverse-on-surface);
  border-radius: var(--shape-xs);
  font-family: var(--font-sans);
  padding: var(--space-1) var(--space-2);
  max-width: 200px;
  pointer-events: none;
  transition: opacity var(--motion-duration-short3)
      var(--motion-easing-standard),
    transform var(--motion-duration-short3) var(--motion-easing-standard);
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: scale(0.95);
}

/* ─── Arrow ─── */

.arrow {
  width: 8px;
  height: 8px;
}

.arrow[data-side="top"] {
  bottom: -4px;
}

.arrow[data-side="bottom"] {
  top: -4px;
}

.arrow[data-side="left"] {
  right: -4px;
}

.arrow[data-side="right"] {
  left: -4px;
}

/* ─── Positioner ─── */

.positioner {
  z-index: var(--z-tooltip);
}
